module.exports = __webpack_public_path__ + "media/images/reduction-6656c9f54fc6591af6eb865239960fea.svg";